var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatePicker(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 5.4502C0.75 4.62177 1.42157 3.9502 2.25 3.9502H21.75C22.5784 3.9502 23.25 4.62177 23.25 5.4502V21.9502C23.25 22.7786 22.5784 23.4502 21.75 23.4502H2.25C1.42157 23.4502 0.75 22.7786 0.75 21.9502V5.4502Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 9.9502H23.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.2002V0.950195",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 6.2002V0.950195",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 13.7002C5.41789 13.7002 5.25 13.8681 5.25 14.0752C5.25 14.2823 5.41789 14.4502 5.625 14.4502C5.83211 14.4502 6 14.2823 6 14.0752C6 13.8681 5.83211 13.7002 5.625 13.7002",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 18.9502C5.41789 18.9502 5.25 19.1181 5.25 19.3252C5.25 19.5323 5.41789 19.7002 5.625 19.7002C5.83211 19.7002 6 19.5323 6 19.3252C6 19.1181 5.83211 18.9502 5.625 18.9502",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.7002C11.7929 13.7002 11.625 13.8681 11.625 14.0752C11.625 14.2823 11.7929 14.4502 12 14.4502C12.2071 14.4502 12.375 14.2823 12.375 14.0752C12.375 13.8681 12.2071 13.7002 12 13.7002",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.9502C11.7929 18.9502 11.625 19.1181 11.625 19.3252C11.625 19.5323 11.7929 19.7002 12 19.7002C12.2071 19.7002 12.375 19.5323 12.375 19.3252C12.375 19.1181 12.2071 18.9502 12 18.9502",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 13.7002C18.1679 13.7002 18 13.8681 18 14.0752C18 14.2823 18.1679 14.4502 18.375 14.4502C18.5821 14.4502 18.75 14.2823 18.75 14.0752C18.75 13.8681 18.5821 13.7002 18.375 13.7002",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 18.9502C18.1679 18.9502 18 19.1181 18 19.3252C18 19.5323 18.1679 19.7002 18.375 19.7002C18.5821 19.7002 18.75 19.5323 18.75 19.3252C18.75 19.1181 18.5821 18.9502 18.375 18.9502",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePicker);
export default __webpack_public_path__ + "static/media/date-picker.769e48c584e8a4ab2e6b4993b2b7bdc5.svg";
export { ForwardRef as ReactComponent };